import Vue from 'vue'
import "@/global/main";
import "@/global/components";
import "@/global/common";
import "@/global/install";
import "@/assets/css/basestyle.css";
import '@/assets/css/elementRewrite.scss';
import App from './App.vue'
import store from '@/store'

import router from './router';
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})

